module.exports = __webpack_public_path__ + "img/footerdt.32ad701c.png";